module.exports = __webpack_public_path__ + "img/gs.7b91751.svg";